// extracted by mini-css-extract-plugin
export default {"footer":"CharacterGenerator_footer__co-aL"};